module.exports = __webpack_public_path__ + "Proxima Nova Regular.410504d49238e955ba7d.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/ucla-prrla/ucla-prrla/ucla-prrla/fonts/Proxima Nova Regular.svg
// module id = ../../../../../fonts/Proxima Nova Regular.svg
// module chunks = 2